import { render, staticRenderFns } from "./AddPayment.vue?vue&type=template&id=dc24700e&scoped=true"
import script from "./AddPayment.vue?vue&type=script&lang=js"
export * from "./AddPayment.vue?vue&type=script&lang=js"
import style0 from "./AddPayment.vue?vue&type=style&index=0&id=dc24700e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc24700e",
  null
  
)

export default component.exports